module.exports = __webpack_public_path__ + "static/media/system.47f0ddc1.svg";